import { resetTasksCache } from "./task/api";
import { resetLocationMetricsCache } from "./location/api";
import { resetRoutePlannerDayCache } from "../state/routePlanner";
import { resetMachineCollectionSummaryCache } from "../liveSales/store";
import { useLiveSalesStore } from "../liveSales/store";

export function resetVendCaches(): void {
  resetTasksCache();
  resetLocationMetricsCache();
  resetRoutePlannerDayCache();
  resetMachineCollectionSummaryCache();
  useLiveSalesStore.getState().reset();
}
